import React, { useState } from 'react'

const Tabs = ({ tabs, variant, selectedTab, onTabChange, defaultSelectedTab, className }) => {
  
  const isControlled = selectedTab !== undefined

  // If uncontrolled, manage state internally.
  // Initialize with defaultSelectedTab or the first tab.
  const [internalSelectedTab, setInternalSelectedTab] = useState(
    defaultSelectedTab || (tabs.length > 0 ? tabs[0].id : null)
  )

  // Determine which value and setter to use.
  const currentTab = isControlled ? selectedTab : internalSelectedTab

  const handleTabClick = (tabId) => {
    if (isControlled) {
      onTabChange(tabId)
    } else {
      setInternalSelectedTab(tabId)
    }
  }

  const { component: Component } = tabs.find((x) => x.id === currentTab)

  return (
    <div className={`tabs ${className ? className : ''}`}>
      <nav className="tabs_container">
        {tabs.map((tab) => (
          <button
            className={`tab ${currentTab === tab.id ? 'tab--active' : ''} ${
              variant ? `tab--${variant}` : ''
            }`}
            onClick={() => handleTabClick(tab.id)}
            key={tab.id}
            type="button"
          >
            {tab.label}
          </button>
        ))}
      </nav>
      <div className="tabs-body">
        <Component />
      </div>
    </div>
  )
}

export default Tabs
